import React, {useState} from 'react';
import PropTypes from 'prop-types';

import MultiStateSpinner from '../../multiStateSpinner/multiStateSpinner';
import ToolTipComponent from '../../toolTipComponent';
import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './buttonComponent.css';

const ButtonComponent = ({
  type = 'primary',
  isDisabled = false,
  showSpinner = false,
  text,
  image,
  spinnerSize = VIDABOO_CONSTANTS.SPINNER_SIZE.MEDIUM,
  toolTipArrowStyle = {},
  toolTipLabelStyle = {},
  toolTipPosition = 'top',
  toolTipTxt = '',
  onClick,
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    if (toolTipTxt) {
      setShowToolTip(!showToolTip);
    }
  };

  const getBackgroundColor = (type) => {
    let settings;
    if (type === 'primary') {
      settings = {
        className: 'et-primary-button',
      };
    } else if (type === 'secondary') {
      settings = {
        className: 'et-secondary-button',
      };
    } else if (type === 'primary-outlined') {
      settings = {
        className: 'et-button-primary-outlined',
      };
    } else if (type === 'other') {
      settings = {
        className: 'et-other-button',
      };
    }
    if (showSpinner || isDisabled) {
      settings.className = settings.className + ' et-btn-disabled';
    }
    return settings;
  };
  return (
    <React.Fragment>
      <button
        className={`et-button-component ${getBackgroundColor(type).className}`}
        onMouseEnter={handleToolTip}
        onMouseLeave={handleToolTip}
        onClick={onClick}
        disabled={showSpinner || isDisabled}>
        {showToolTip && (
          <ToolTipComponent
            toolTipArrowStyle={toolTipArrowStyle}
            toolTipLabelStyle={toolTipLabelStyle}
            toolTipPosition={toolTipPosition}
            toolTipTxt={toolTipTxt}
          />
        )}
        {showSpinner ? (
          <MultiStateSpinner
            spinnerColor={
              type === 'primary'
                ? VIDABOO_CONSTANTS.SPINNER_COLOR.WHITE
                : VIDABOO_CONSTANTS.SPINNER_COLOR.BLUE
            }
            spinnerSize={spinnerSize}
          />
        ) : (
          <>
            {image ? image : null}
            {text}
          </>
        )}
      </button>
    </React.Fragment>
  );
};

export default ButtonComponent;

ButtonComponent.propTypes = {
  type: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  image: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  showSpinner: PropTypes.bool,
  toolTipPosition: PropTypes.string,
  toolTipTxt: PropTypes.string,
};
